import {ExamSession} from "./examSession";
import { Exam } from "./exam";
import {User} from "./user";

const EMAIL_STATUS_DISPLAYS: {[status: string]: {label: string, textClass: string, iconClass: string, title: string}} = {
    sent: {label: "Envoyé", textClass: "text-secondary", iconClass: "fa-arrow-circle-right", title: "Envoyé, en attente de confirmation"},
    delivered: {label: "Délivré", textClass: "text-success", iconClass: "fa-check-circle", title: "Email délivré avec succès"},
    opened: {label: "Ouvert", textClass: "text-info", iconClass: "fa-dot-circle", title: "Email ouvert par le candidat"},
    clicked: {label: "Cliqué", textClass: "text-info", iconClass: "fa-play-circle", title: "Le candidat a cliqué sur un lien dans l'email"},
    hard_bounce: {label: "Erreur", textClass: "text-danger", iconClass: "fa-exclamation-circle", title: "Adresse email invalide — contacter le candidat autrement"},
    soft_bounce: {label: "Temporaire", textClass: "text-warning", iconClass: "fa-clock", title: "Erreur temporaire (boîte pleine) — Brevo réessaie automatiquement"},
    blocked: {label: "Bloqué", textClass: "text-danger", iconClass: "fa-ban", title: "Email bloqué par le serveur — contacter le candidat"},
    error: {label: "Erreur", textClass: "text-danger", iconClass: "fa-exclamation-circle", title: "Erreur technique à l'envoi"},
};

const UNTRACKED_EMAIL_DISPLAY = {label: "Aucun", textClass: "text-secondary", iconClass: "fa-minus-circle", title: "Pas de suivi disponible"};


export class Convocation {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    phoneNumber: string | null;
    sessionCode: string;
    voucherCode: string;
    convocationSentAt: Date;
    examCenterName: string | null;
    certificationName: string | null;
    sessionDate: Date | null;
    studentConfirmed: boolean | null;
    nbEnvois: number;
    emailStatus: string | null;
    emailStatusChangedAt: Date | null;

    constructor(data: any) {
        this.id = data.id;
        this.firstname = data.first_name;
        this.lastname = data.last_name;
        this.email = data.email;
        this.phoneNumber = data.phone_number;
        this.sessionCode = data.session_code;
        this.voucherCode = data.voucher_code;
        this.convocationSentAt = data.convocation_sent_at ? new Date(data.convocation_sent_at) : new Date(data.created_date);
        this.examCenterName = data.exam_center_name || null;
        this.certificationName = data.certification_name || null;
        this.sessionDate = data.session_date ? new Date(data.session_date) : null;
        this.studentConfirmed = data.student_confirmed !== undefined ? data.student_confirmed : null;
        this.nbEnvois = data.nb_envois || 1;
        this.emailStatus = data.email_status || null;
        this.emailStatusChangedAt = data.email_status_changed_at ? new Date(data.email_status_changed_at) : null;
    }

    get emailStatusDisplay () {
        return EMAIL_STATUS_DISPLAYS[this.emailStatus] || UNTRACKED_EMAIL_DISPLAY;
    }
}

export class Preregistration {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    phoneNumber: string | null;
    session: ExamSession;
    exam: Exam | null = null;
    fileNumber: string | null = null;
    convocationSentAt: Date | null = null;
    convocationIsSending: boolean = false;
    psh: boolean = false;
    pshComment: string | null = null;

    convocations: Convocation[] = [];

    createdDate: Date;
    author: User;

    constructor (data: any) {
        if (data) {
            this.id = data.id;
            this.firstname = data.first_name;
            this.lastname = data.last_name;
            this.email = data.email;
            this.session = new ExamSession(data.session);
            this.createdDate = new Date(data.created_date);
            this.author = new User(data.author);
            this.psh = data.psh;
            this.pshComment = data.psh_comment;
            
            if (data.phone_number) {
                this.phoneNumber = data.phone_number;
            }

            if (data.file_number) {
                this.fileNumber = data.file_number;
            }

            if (data.exam) {
                this.exam = new Exam(data.exam);
            }         

            if (data.convocation_sent_at) {
                this.convocationSentAt = new Date(data.convocation_sent_at);
            }

            for (let convocation of data.convocations) {
                this.convocations.push(new Convocation(convocation));
            }

        }
    }

    // Même règle que le filtre « A envoyer » côté back : une convocation envoyée
    // pour une autre session ou un autre ticket ne compte pas.
    get hasCurrentConvocation (): boolean {
        return this.exam != null && this.convocations.some((convocation) => {
            return convocation.sessionCode === this.session.code &&
                convocation.voucherCode === this.exam.voucher_code;
        });
    }

    get convocationBlockedReason (): string | null {
        if (this.session.status === "deleted") {
            return "La session est supprimée";
        }

        if (this.session.isPast || this.session.isFinished) {
            return "La session est passée";
        }

        return null;
    }

    studentConfirmedAt() {
        if (this.exam == null) {
            return null;
        }

        return this.exam.studentConfirmedAt;
    }

    ticketUsedAt() {
        if (this.exam == null) {
            return null;
        }

        return this.exam.usedAt;
    }

    canSendConvocation() {
        return this.exam != null && this.exam.certification != null && this.studentConfirmedAt() == null && this.ticketUsedAt() == null;
    }

}

